import LassoModal from '../../../../components/LassoModal';
import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { LassoTab, LassoTabs } from '../../../../components/LassoTabs';
import QueriesList from './QueriesList';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import useUserQueries from '../../hooks/useUserQueries';

const LoadQueryModal = ({ open, setOpen }: any) => {
    const {
        queryTypes,
        selectedQuery,
        selectedQueryType,
        setSelectedQuery,
        handleTabChange,
        onSubmitLoadQuery,
        shouldDisableLoadButton
    } = useUserQueries({ setOpen });


    return (
        <LassoModal open={open} onClose={() => setOpen(false)}>
            <Stack>
                <Stack flexDirection="row" justifyContent="space-between">
                    <Typography fontSize="24px" fontWeight="600">Select query to load</Typography>
                    <IconButton onClick={() => setOpen(false)}>
                        <HighlightOffIcon/>
                    </IconButton>
                </Stack>
                <LassoTabs value={selectedQueryType} onChange={handleTabChange}>
                    <LassoTab label="My Queries" value="own"/>
                    <LassoTab label="Queries Shared with me" value="shared"/>
                </LassoTabs>
                <Box width="550px" minHeight="550px">
                    <QueriesList
                        queries={queryTypes[selectedQueryType] ?? []}
                        selectedQuery={selectedQuery}
                        setSelectedQuery={setSelectedQuery}
                    />
                </Box>
                <Button variant="primary" onClick={onSubmitLoadQuery} sx={{ alignSelf: "center", mt: 3 }} disabled={shouldDisableLoadButton()}>Load Query</Button>
            </Stack>
        </LassoModal>
    )
}

export default LoadQueryModal